/**
 * @file Screen Related Helpers.
 */

import get from 'lodash.get';

/**
 * Returns the screen size without taking into account pixelRatio.
 */
export const getScreenResolution = () => {
  return {
    width: get(window, 'innerWidth', 0),
    height: get(window, 'innerHeight', 0),
  };
};

/**
 * Returns the overall screen size.
 */
export const getTrueScreenResolution = () => {
  return {
    width: get(window, 'innerWidth', 0) * get(window, 'devicePixelRatio', 1),
    height: get(window, 'innerHeight', 0) * get(window, 'devicePixelRatio', 1),
  };
};

/**
 * Given a resolution object, will swap out width & height.
 *
 * @param {Object} resolution Screen resolution object containing width & height.
 * @param {number} resolution.width The width.
 * @param {number} resolution.height The height.
 */
export const rotateResolution = ({ width, height }) => {
  return {
    width: height,
    height: width,
  };
};

/**
 * Given a resolution object, will return whether this is a vertical display or not.
 *
 * @param {Object} resolution Screen resolution object containing width & height.
 * @param {number} resolution.width The width.
 * @param {number} resolution.height The height.
 */
export const isPortraitResolution = ({ width, height }) => height > width;
